module.exports = __webpack_public_path__ + "static/media/file-edit.db25c5d2.svg";